<template>
<div class="subpage main_area">
	<div class="fullpage_white subpage">
		<div class="sponsor_menu infotab">
			<div class="layout aboutus_layout">
				<div class="infotab_bg cs_type_menu about_menu">
					<div class="sponsor_menu_item about_item"> <a class="active">
						<div class="title">关于我们</div>
						</a> </div>
					<div class="sponsor_menu_item about_item"> <a>
						<div class="title">规则条款</div>
						</a> </div>
					<div class="sponsor_menu_item about_item"> <a>
						<div class="title">隐私政策</div>
						</a> </div>
					<div class="sponsor_menu_item about_item"> <a>
						<div class="title">博彩责任</div>
						</a> </div>
				</div>
			</div>
		</div>
		<!--关于我们-->
		<div class="display_container">
			<div class="fullpage_white subpage">
				<div class="about_container layout">
					<!-- <div class="logo"></div>
					<div class="title">澳门金沙集团，挚诚卓越的娱乐品牌</div> -->
					<div v-html="dataBox7.content"></div>
				</div>
			</div>
		</div>
		<!--规则条款-->
		<div class="display_container" style="display:none;">
			<div class="fullpage_white subpage">
				<div class="terms_container layout">
					<div v-html="dataBox3.content"></div>
					
				</div>
			</div>
		</div>
		<!--隐私政策-->
		<div class="display_container" style="display:none;">
			<div class="fullpage_white subpage">
				<div class="privacy_container layout"  v-html="dataBox2.content">
					
				</div>
			</div>
		</div>
		<!--博彩责任-->
		<div class="display_container" style="display:none;">
			<div class="fullpage_white subpage">
							<div class="privacy_container layout"  v-html="dataBox8.content"></div>

			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
  name: 'about',
  data() {
	 // 1常见问题  2隐私政策  3免责说明  4联系我们  5代理加盟  7关于我们 8博彩责任  
    return {  dataBox1: {}, dataBox2: {}, dataBox3: {}, dataBox4: {}, dataBox5: {},  dataBox7: {}, dataBox8: {} };
  },
  created() {
    let that = this;
        let arr = [1, 2, 3, 4, 5, 7, 8];
    arr.forEach(el => {
      that.getAllCont(el);
    });
  },
  methods: {
     getAllCont(type) {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/article', { type })
        .then(res => {
          let name = 'dataBox' + type;
          that[name] = res.data;
          console.log(type);
          console.log(that[name].content);
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;

   //页面内容切换
$(".about_menu .about_item").click(function(){
	var index=$(this).index();
	$(".about_menu .about_item a").removeClass("active").eq(index).addClass("active");
	$(".display_container").fadeOut(0).eq(index).fadeIn(300);
});
 
  },
  updated() {
    let that = this;
  

  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.about_menu a.active {
    border-bottom: var(--infotab_indicator_height) solid var(--infotab_indicator);
    border-radius: unset;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/about.vue